<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{this.updateUser ? "Update User" : "Create New User"}}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                      cols="12 pl-0"
                      align="center"
                      justify="center"
                    >
                      <v-btn-toggle
                        v-model="text"
                        tile
                        color="deep-purple accent-3"
                        group
                        class="text-center"
                        rounded
                        mandatory
                      >
                        <v-btn value="Details">
                          Details
                        </v-btn>
                        <v-btn value="Password" v-if="updateUser">
                          Password
                        </v-btn>
                        <v-btn value="Assignment">
                          Office and Position
                        </v-btn>
                        <v-btn value="Permissions">
                          Permissions
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                </v-row>
                <v-row v-if="text == `Password`">
                  <v-col cols="12">
                    <v-text-field
                        aria-autocomplete="off"
                        label="New Password*"
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        hint="At least 6 characters"
                        counter
                        @click:append="show1 = !show1"
                        required
                      ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                      <v-text-field
                        aria-autocomplete="off"
                        label="Confirm Password*"
                        v-model="confirm_password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        hint="At least 6 characters"
                        counter
                        @click:append="show1 = !show1"
                        required
                      ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="text == 'Details'">
                  <v-col cols="4">
                    <v-text-field
                      aria-autocomplete="off"
                      label="First Name*"
                      v-model="first_name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Middle Name*"
                      v-model="middle_name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Last Name*"
                      v-model="last_name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Email*"
                      v-model="email"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Mobile Number*"
                      v-model="mobile_number"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6"  v-if="!updateUser">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Password*"
                      v-model="password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="show1 ? 'text' : 'password'"
                      hint="At least 6 characters"
                      counter
                      @click:append="show1 = !show1"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" v-if="!updateUser">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Confirm Password*"
                      v-model="confirm_password"
                      :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :rules="[rules.required, rules.min]"
                      :type="show1 ? 'text' : 'password'"
                      hint="At least 6 characters"
                      counter
                      @click:append="show1 = !show1"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-else-if="text == 'Assignment'">
                  <v-col cols="12">
                    <v-select
                      :items="allOffices"
                      label="Assign Office*"
                      item-value="id"
                      v-model="office_id"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="allPositions"
                      label="Select Position*"
                      item-value="id"
                      v-model="position_id"
                    >
                      <template slot="selection" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                      </template>
                      <template slot="item" slot-scope="{ item }">
                        <!-- HTML that describe how select should render selected items -->
                        {{ item.name }}
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row v-else-if="text == 'Permissions'">
                  <v-col cols="12" class="text-center">
                    <v-btn-toggle
                      v-model="toggle_permission"
                      rounded
                      mandatory
                    >
                      <v-btn x-small value="permission_groups">
                        Update Permission Group
                      </v-btn>
                      <v-btn x-small value="manual_assignment">
                        Manually Select Permission
                      </v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <v-row v-if="toggle_permission == 'permission_groups'">
                    <v-col cols="10" offset="1" class="mt-6">
                      <v-select label="Select User Role" 
                      :items="allPermissionGroups" 
                      v-model="permission_group_select" 
                      item-value="name"
                        return-object
                      >
                        <template slot="selection" slot-scope="{ item }">
                            <!-- HTML that describe how select should render selected items -->
                            {{ item.name }}
                        </template>
                        <template slot="item" slot-scope="{ item }">
                            <!-- HTML that describe how select should render selected items -->
                            {{ item.name }}
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="toggle_permission == 'manual_assignment'">
                    <v-col cols="6">
                      Assigned
                    </v-col>
                    <v-col cols="6">
                      Not Assigned
                    </v-col>
                    <v-col cols="6" class="permission-box">
                      <ul v-for="permission in getAssignedPermissions" :key="permission.id">
                        <li @dblclick="remove(permission)">
                          {{ permission.name }}
                        </li>
                      </ul>
                    </v-col>
                    <v-col cols="6" class="permission-box">
                      <ul v-for="permission in filterPermission()" :key="permission.id">
                        <li @dblclick="add(permission)">{{ permission.name }}</li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-row>
                <v-row>
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">{{ errorMessage }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveNewUser" :disabled="disableSave">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
    <RouteAssignment @closeDialog="closeModal" :dialog="routeDialog" :userID="userID"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Swal from 'sweetalert2';
import LoadingOverlay from "./common/LoadingOverlay.vue";
import RouteAssignment from "./users/modal/RouteAssignment.vue"
export default {
  name: "UserCreateModal",
  props: {
    dialog: Boolean,
    updateUser: Object,
  },
  components: {
    LoadingOverlay,
    RouteAssignment
  },
  data() {
    return {
      userID: null,
      disableSave: false,
      loading: false,
      first_name: "",
      middle_name: "", 
      last_name: "",
      email: "",
      mobile_number: "",
      password: "",
      toggle_permission: 'permission_groups',
      confirm_password: "",
      status: "Active",
      showSuccess: false,
      text: "Details",
      office_id: null,
      position_id: null,
      errorMessage: null,
      permission_group_select: null,
      show1: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 6 || 'Min 6 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
      updateItem: null,
      email_list: [],
      isUpdate: false,
      routeDialog: false,
      unAssignedPermission: null
    };
  },
  methods: {
    ...mapActions(["createUser", 'userUpdate', "fetchPositions", "fetchOffices", 'fetchUnassignedPermissions', 'addPermission', 'removePermission', 'saveUpdatedPermissions', 'fetchPermissionGroups']),
    filterPermission() {
      return this.getUnassignedPermissions
    },
    validate(){
      this.allUsers.forEach(item => {
        this.email_list.push(item.email)
      })
      if(this.email_list.some(item => this.email == item)){
        this.errorMessage = "Email already exist"
        return true
      }else{
        this.errorMessage = ""
        return false
      }
    },
    passwordValidation() {
      if(this.password){
        if(this.password.length < 6){
          this.errorMessage = "Password must be 6 characters long"
          return true
        }
        return false
      }
    },
    updateValidation() {
      if(this.first_name == ""){
        this.errorMessage = "First name must not be empty"
        return true
      }else if(this.first_name.length < 2){
        this.errorMessage = "First name must be 2 characters long"
        return true
      }
    },
    async saveNewUser() {
      this.disableSave=true;
      this.loading=true;
      let body = {};
      let save;
      if(this.toggle_permission == 'permission_groups') {
        if(this.permission_group_select) {
          
          body.permission_group_select = this.permission_group_select;
        }
        // if(!this.permission_group_select) {
        //   this.errorMessage = 'Permision group is required';
        //   this.loading=false;
        //   this.disableSave=false;
        //   return true;
        // } else {
        //   body.permission_group_select = this.permission_group_select;
        // }
      }
      if(this.updateItem) {
        this.isUpdate = true;
        if(this.password == ""){
            body = Object.assign(body, {
            first_name: this.first_name,
            middle_name: this.middle_name,
            last_name: this.last_name,
            email: this.email,
            position_id: this.position_id,
            office_id: this.office_id,
            mobile_number: this.mobile_number,
            user_id: this.updateItem.id,
            currentData: this.updateItem
          })
        }else{
          let error = this.passwordValidation()
          if(error){
            this.loading = false
            this.disableSave = false;
            return
          }
          body = Object.assign(body, {
            first_name: this.first_name,
            middle_name: this.middle_name,
            last_name: this.last_name,
            email: this.email,
            position_id: this.position_id,
            password: this.password,
            confirm_password: this.confirm_password,
            office_id: this.office_id,
            mobile_number: this.mobile_number,
            user_id: this.updateItem.id,
            currentData: this.updateItem
          })
        }
        save = await this.userUpdate(body)
      } else {
        this.isUpdate = false;
        let emailExist = this.validate();
        body = Object.assign(body, {
          first_name: this.first_name,
          middle_name: this.middle_name,
          last_name: this.last_name,
          email: this.email,
          password: this.password,
          confirm_password: this.confirm_password,
          position_id: this.position_id,
          office_id: this.office_id,
          mobile_number: this.mobile_number,
        })
        if(!emailExist){
          save = await this.createUser(body)
        }else{
          this.disableSave=false;
          this.loading = false
          return
        }
      }
      if(save.error) {
        this.disableSave=false;
        this.loading = false
        if(save.status == 400) this.errorMessage = save.message;
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Internal Server Error',
          })
        }
      } else if(save) {
        if(this.updateItem)
          this.checkRouteAssignment()
        this.disableSave=false;
        this.loading = false
        this.first_name = '';
        this.middle_name = '';
        this.last_name = '';
        this.email = '';
        this.mobile_number = '';
        this.password = '';
        this.confirm_password = '';
        this.office_id = null;
        this.position_id = null;
        this.text = "Details";
        this.$emit('closeDialog', true, this.isUpdate);
        this.updateItem = null;
      }
    },
    checkRouteAssignment(){
      if(this.updateUser.offices[0].id !== this.office_id && this.updateUser.positions[0].id !== this.position_id){
        if(this.getAssignedRoute.length > 0 || this.getAssignedSubRoute.length > 0){
          Swal.fire({
            title: "User has existing routes. Do you wish to re-assign the routes?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, reassign it!",
            cancelButtonText: "No, cancel!",
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.routeDialog = true;
            }
          });
        }
      }
    },
    closeModal() {
      this.routeDialog = false;
    },
    remove(item) {
      this.removePermission(item);
    },
    add(item) {
      this.addPermission(item);
    },
    close() {
      this.disableSave=false;
      this.first_name = '';
      this.middle_name = '';
      this.last_name = '';
      this.email = '';
      this.mobile_number = '';
      this.password = '';
      this.confirm_password = '';
      this.office_id = null;
      this.position_id = null;
      this.text = "Details";
      this.updateItem = null;
      this.$emit('closeDialog', false, "close");
    }
  },
  computed: mapGetters(["getAssignedSubRoute","getAssignedRoute","allPositions", "allOffices", "allRoutes", 'getUnassignedPermissions', 'getAssignedPermissions', 'allPermissionGroups', 'allUsers']),
  created() {
    this.fetchPositions({});
    this.fetchOffices({ itemsPerPage: 0 });
    this.fetchPermissionGroups({ itemsPerPage: 0 });
  },
  watch: {
    dialog: function () {
      this.errorMessage = ""
      if(!this.updateUser) {
        this.fetchUnassignedPermissions({ id: -1, permissions: [] })
      }
    },
    updateUser: function() {
      if(this.updateUser) {
        this.updateItem = this.updateUser;
        this.first_name = this.updateUser.first_name;
        this.middle_name = this.updateUser.middle_name;
        this.last_name = this.updateUser.last_name;
        this.email = this.updateUser.email;
        this.password = this.updateUser.password;
        this.confirm_password = this.updateUser.password;
        this.office_id = this.updateUser.offices[0] ? this.updateUser.offices[0].id : -1
        this.position_id = this.updateUser.positions[0] ? this.updateUser.positions[0].id : -1;
        this.mobile_number = this.updateUser.mobile_number;
        this.userID = this.updateUser.id
        this.fetchUnassignedPermissions({ id: this.updateUser.id, permissions: this.updateUser.permissions});
      } else {
        this.updateItem = null;
      }
    },
  }
};
</script>

<style scoped>
  .permission-box {
    overflow: auto;
    overflow-x:hidden;
    height: 300px;
    border-style: solid;
    border-width: thin;
    border-color: #d1d1d1;
  }

  ul {
    padding: 0px;
    margin-top: 0px;
  }

  li {
    list-style: none;
    border-bottom: solid;
    border-width: thin;
    padding-bottom: 6px;
    padding-top: 6px;
    cursor: pointer;
  }
  
  li:hover {
    background-color: rgb(230, 230, 230);
  }
</style>